export function setAdvancePayments(state, advance_payments) {
  state.advance_payments = advance_payments; 
}
export function setCompanies(state, companies) {
  state.companies = companies; 
} 